/**
 * Snap tools. Values are the server enum names (AvaInspectSnapTool in aiva.api).
 */
export const SNAP_TOOLS = Object.freeze({
  EDGE_SNAP: 'EdgeSnap',
  MAGNETIC_LASSO: 'MagneticLasso',
  MAGIC_WAND: 'MagicWand',
});

export const SNAP_TOOL_META = Object.freeze({
  [SNAP_TOOLS.EDGE_SNAP]: {
    label: 'Edge snap',
    icon: 'mdi-vector-polygon',
    tooltip: 'Edge snap: click points that jump to the nearest edge',
    hint: 'Click to add points. They jump to nearby edges; hold Alt to place a point exactly.',
  },
  [SNAP_TOOLS.MAGNETIC_LASSO]: {
    label: 'Magnetic lasso',
    icon: 'mdi-lasso',
    tooltip: 'Magnetic lasso: the outline follows edges between your clicks',
    hint: 'Click to set anchors. The outline follows edges between them; hold Alt for a straight line.',
  },
  [SNAP_TOOLS.MAGIC_WAND]: {
    label: 'Magic wand',
    icon: 'mdi-auto-fix',
    tooltip: 'Magic wand: click inside an area to select similar colours',
    hint: 'Click inside the area to select it. Click elsewhere to try again, or change the tolerance.',
  },
});

export const WAND_TOLERANCE = Object.freeze({ MIN: 4, MAX: 120, DEFAULT: 32 });

/** Radius (CSS px) within which a point looks for an edge. */
export const EDGE_SNAP_RADIUS = 12;
